import { create } from "zustand";

/** Un document de l'ordre à joindre dans la conversation client (clic droit sur un
 *  document → « Envoyer au client »). Le chat visible le reprend dans sa zone de saisie :
 *  canal, fenêtre WhatsApp 24 h et sourdine restent ceux du chat, l'envoi reste un clic. */
export interface StagedChatFile {
  discussionId: string;
  file: File;
  type: "image" | "file";
}

interface ChatStageState {
  pending: StagedChatFile | null;
  stage: (s: StagedChatFile) => void;
  take: (discussionId: string) => StagedChatFile | null;
}

export const useChatStageStore = create<ChatStageState>((set, get) => ({
  pending: null,
  stage: (s) => set({ pending: s }),
  take: (discussionId) => {
    const p = get().pending;
    if (!p || p.discussionId !== discussionId) return null;
    set({ pending: null });
    return p;
  },
}));
